import { InfoOutlined } from '@mui/icons-material'
import { Box, Button, Fade, Grid, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { toggleFormSlider } from '../../../../../redux/actions/sliders'
import CustomChip from '../../../../shared/components/CustomChip'
import AdminContentFilter from '../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import { tableScreenStyles } from '../../../../shared/styles/TableScreenStyles'
import { IFilter, IOption } from '../../models/sliders'
import useScreenWidth from '@/contexts/shared/hooks/useScreenWidth'

interface SlidersFiltersProps {
  filters: IFilter
  optionsData: IOption[]
  handleClickSetOptions: (options: any) => void
}

export function SlidersFilters({ filters, optionsData, handleClickSetOptions }: SlidersFiltersProps) {
  const isMobile = useScreenWidth(700)
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const theme = useTheme()
  const styles = tableScreenStyles(theme)

  return (
    <Box
      sx={{
        mt: isMobile ? 2 : 6,
        display: 'flex',
        flexDirection: isMobile ? 'column-reverse' : 'column',
        gap: 2
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography variant="h5" align="center">
          {t('all')}
        </Typography>
        <Tooltip
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}
          arrow
          title={
            <Box>
              <Typography variant="body2">{t('status')}:</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CustomChip size="small" color="primary" />
                <Typography variant="caption">{t('active')}</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CustomChip size="small" color="secondary" />
                <Typography variant="caption">{t('inactive')}</Typography>
              </Box>
            </Box>
          }
        >
          <IconButton size="small">
            <InfoOutlined sx={{ color: '#8F99A3' }} fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item xs={5} sm={6}>
            <Box sx={styles.actionsResponsive}>
              <Button id="btn-create-slider" variant="outlined" color="secondary" onClick={() => dispatch(toggleFormSlider())}>
                {t('create')} {filters.modal_title}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={7} sm={6}>
            <Box sx={styles.actionsResponsiveRight}>
              <AdminContentFilter data={optionsData} handleClick={handleClickSetOptions} />
              <CountriesFilter />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
